import { DeliveryNoteHandlingUnitSearchCriteria, DeliveryNoteParams } from '../../../models';

export class DeliveryNoteHandlingUnits {
  public static readonly type = '[DeliveryNoteHandlingUnits] Load Handling Units';
  constructor(
    public payload: {
      deliveryNoteParams: DeliveryNoteParams;
      searchCriteria: DeliveryNoteHandlingUnitSearchCriteria;
    },
  ) {}
}

export class DeliveryNoteHandlingUnitsInitialState {
  public static readonly type = '[DeliveryNoteHandlingUnits] Set Initial State';
}
